function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createForm, useToasts } from '@applyboard/crystal-ui';
import { useCreateNote } from "../../data/notes";
import { ApplicationActionName } from "../../../../types";
import { useApplicationAvailableActions } from "../../data";
import { z } from 'zod';
import { useSessionStorage, useTranslation } from '@applyboard/ui-utils';
import { useParams } from 'react-router-dom';
import { useUser } from '@applyboard/abid-provider';
import { useNotesListContext } from "./NotesListProvider";
import { useApplication } from "../../data/application";
import { NoteFormValues } from "./NoteList.types";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var NOTE_DRAFT_KEY_PREFIX = 'ab-application-note-draft';
var SerializableNoteFormValues = NoteFormValues.omit({
  attachments: true
}).extend({
  attachments: z.array(z.object({
    errorMessage: z.string().optional(),
    warningMessage: z.string().optional(),
    uploading: z["boolean"]().optional(),
    file: z.object({
      name: z.string()
    }),
    id: z.string()
  }))
});
var DEFAULT_FORM_VALUES = Object.freeze({
  content: '',
  restricted: false,
  emailNotification: false,
  subject: '',
  attachments: [],
  noteTemplateNumber: null,
  parentNoteId: null
});
var _createForm = createForm({
    provider: true
  }),
  Form = _createForm.Form,
  FormProvider = _createForm.FormProvider,
  Field = _createForm.Field,
  useFieldValues = _createForm.useFieldValues,
  useGetFieldValues = _createForm.useGetFieldValues,
  useSetFieldValues = _createForm.useSetFieldValues;

/**
 * Saves the note draft to session storage
 */
function NoteDraftSaver() {
  var _useNotesListContext = useNotesListContext(),
    noteForm = _useNotesListContext.noteForm;
  var values = useFieldValues();
  var _useDraftNote = useDraftNote({
      replyToId: noteForm.replyToId
    }),
    setDraftNote = _useDraftNote.setDraftNote;

  // eslint-disable-next-line no-restricted-syntax -- Form does not have a global onChange prop, otherwise we could use that
  useEffect(function () {
    if (noteForm.isOpen) {
      setDraftNote(values);
    }
  }, [values, noteForm.isOpen, setDraftNote]);
  return null;
}
export function useDraftNote(_ref) {
  var replyToId = _ref.replyToId;
  var user = useUser();
  var _useNotesListContext2 = useNotesListContext(),
    noteType = _useNotesListContext2.noteType;
  var _useParams = useParams(),
    application_id = _useParams.application_id;
  var key = generateDraftKey({
    user: user,
    applicationId: application_id,
    noteType: noteType,
    replyToId: replyToId
  });
  var _useSessionStorage = useSessionStorage(key, {
      schema: SerializableNoteFormValues
    }),
    _useSessionStorage2 = _slicedToArray(_useSessionStorage, 2),
    draft = _useSessionStorage2[0],
    setDraft = _useSessionStorage2[1];
  return {
    draftNote: useMemo(function () {
      if (!draft) {
        return null;
      }
      return _objectSpread(_objectSpread({}, draft), {}, {
        attachments: draft.attachments.map(function (attachment) {
          return _objectSpread(_objectSpread({}, attachment), {}, {
            file: new File([], attachment.file.name)
          });
        })
      });
    }, [draft]),
    setDraftNote: useCallback(function (values) {
      if (!values) {
        setDraft(null);
        return;
      }
      var newDraft = _objectSpread(_objectSpread({}, values), {}, {
        attachments: values.attachments.map(function (attachment) {
          return _objectSpread(_objectSpread({}, attachment), {}, {
            file: {
              name: attachment.file.name
            }
          });
        })
      });
      setDraft(newDraft);
    }, [setDraft])
  };
}
function generateDraftKey(_ref2) {
  var user = _ref2.user,
    applicationId = _ref2.applicationId,
    noteType = _ref2.noteType,
    replyToId = _ref2.replyToId;
  return "".concat(NOTE_DRAFT_KEY_PREFIX, "-").concat(applicationId, "-").concat(JSON.stringify({
    noteType: noteType,
    replyToId: replyToId,
    userId: user.abUserId
  }));
}
export function clearNoteDrafts(applicationId) {
  for (var i = 0; i < sessionStorage.length; i++) {
    var key = sessionStorage.key(i);
    if (key !== null && key !== void 0 && key.startsWith("".concat(NOTE_DRAFT_KEY_PREFIX, "-").concat(applicationId, "-"))) {
      sessionStorage.removeItem(key);
    }
  }
}
export function useDefaultNoteFormValues(currentCreatorPersona) {
  var _useNotesListContext3 = useNotesListContext(),
    noteType = _useNotesListContext3.noteType;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    getApplicationAvailableAction = _useApplicationAvaila.getApplicationAvailableAction;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useTranslation = useTranslation('NotesList'),
    t = _useTranslation.t;
  var createNoteAction = getApplicationAvailableAction(noteType === 'customer' ? ApplicationActionName.CREATE_CUSTOMER_NOTE : ApplicationActionName.CREATE_ADMIN_NOTE);
  var emailRpAllowed = (createNoteAction === null || createNoteAction === void 0 ? void 0 : createNoteAction.additionalInformation) && 'emailRpAllowed' in createNoteAction.additionalInformation && createNoteAction.additionalInformation.emailRpAllowed;
  if (currentCreatorPersona === 'applyboard_support_team') {
    var replyingTo = application.rpFullName || application.student.fullName;
    return _objectSpread(_objectSpread({}, DEFAULT_FORM_VALUES), {}, {
      content: t('defaultNoteContent', {
        replyingTo: replyingTo
      }),
      emailNotification: !!emailRpAllowed
    });
  } else {
    return _objectSpread(_objectSpread({}, DEFAULT_FORM_VALUES), {}, {
      emailNotification: !!emailRpAllowed
    });
  }
}
function useClearNoteForm(currentCreatorPersona) {
  var defaultValues = useDefaultNoteFormValues(currentCreatorPersona);
  var setFieldValues = useSetFieldValues();
  return function () {
    setFieldValues(defaultValues);
  };
}
function NoteFormProvider(_ref3) {
  var children = _ref3.children,
    currentCreatorPersona = _ref3.currentCreatorPersona;
  var _useNotesListContext4 = useNotesListContext(),
    noteForm = _useNotesListContext4.noteForm,
    noteType = _useNotesListContext4.noteType;
  var defaultValues = useDefaultNoteFormValues(currentCreatorPersona);
  var _useDraftNote2 = useDraftNote({
      replyToId: noteForm.replyToId
    }),
    draftNote = _useDraftNote2.draftNote,
    setDraftNote = _useDraftNote2.setDraftNote;
  return _jsxs(FormProvider, {
    defaultValues: draftNote || defaultValues,
    onSubmit: function onSubmit(values) {
      return noteForm.handleSubmit({
        noteType: noteType,
        values: values,
        setDraftNote: setDraftNote
      });
    },
    children: [children, _jsx(NoteDraftSaver, {})]
  });
}
export { Form, NoteFormProvider, Field, useFieldValues, useGetFieldValues, useSetFieldValues, useClearNoteForm };

/**
 * Creates some controls to manage the note form creation state (open/close,
 * creating the note, etc.)
 *
 * The form values themselves are not managed here
 */
export function useNoteForm() {
  var _useState = useState({
      isOpen: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    openState = _useState2[0],
    setOpenState = _useState2[1];
  var _useCreateNote = useCreateNote(),
    createNote = _useCreateNote.createNote,
    createNoteStatus = _useCreateNote.createNoteStatus,
    createNoteError = _useCreateNote.createNoteError;
  var toasts = useToasts();
  var _useTranslation2 = useTranslation('NotesList'),
    t = _useTranslation2.t;
  var createButtonRef = useRef(null);
  var newNoteMarkerRef = useRef(null);
  var refs = useMemo(function () {
    return {
      createButton: createButtonRef,
      newNoteMarker: newNoteMarkerRef
    };
  }, []);
  var close = useCallback(function () {
    var _refs$createButton$cu;
    setOpenState({
      isOpen: false
    });
    (_refs$createButton$cu = refs.createButton.current) === null || _refs$createButton$cu === void 0 ? void 0 : _refs$createButton$cu.focus();
  }, [refs.createButton]);
  var open = useCallback(function () {
    var _refs$newNoteMarker$c;
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      replyToId = _ref4.replyToId;
    setOpenState({
      isOpen: true,
      replyToId: replyToId
    });
    (_refs$newNoteMarker$c = refs.newNoteMarker.current) === null || _refs$newNoteMarker$c === void 0 ? void 0 : _refs$newNoteMarker$c.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }, [refs.newNoteMarker]);
  return useMemo(function () {
    return {
      isOpen: openState.isOpen,
      replyToId: openState.replyToId,
      open: open,
      close: close,
      handleSubmit: function handleSubmit(_ref5) {
        var noteType = _ref5.noteType,
          values = _ref5.values,
          setDraftNote = _ref5.setDraftNote;
        if (values.attachments.length > 10) {
          return;
        }
        createNote({
          type: noteType === 'customer' ? 'application_customer_note' : 'application_admin_note',
          subject: values.subject,
          content: values.content,
          flags: {
            restricted: values.restricted,
            emailNotification: values.emailNotification
          },
          noteTemplateNumber: values.noteTemplateNumber,
          parentNoteId: values.parentNoteId,
          attachments: values.attachments.map(function (attachment) {
            return {
              id: attachment.id
            };
          })
        }, {
          onSuccess: function onSuccess() {
            toasts.positive(t('noteSuccessfullyCreated'));
            close();
            setDraftNote(null);
          }
        });
      },
      createNoteStatus: createNoteStatus,
      createNoteError: createNoteError,
      refs: refs
    };
  }, [createNote, createNoteStatus, createNoteError, openState, refs, close, open, t, toasts]);
}